import Super from './ghost.gjs';

const METADATA = {
  component: 'Spds::Action::Button::Link',
  description: `
    Link button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Link Button',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/link.gjs',
  },
};

export default class SpdsActionButtonLink extends Super {
  static metadata = this.setMetadata(METADATA);
  classesToMapToAttrs = ['link'];
  link = true;
}

export const ACTION_BUTTON_LINK_METADATA = SpdsActionButtonLink.metadata;
